import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Carousel } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../App";

export default function PerfumeBlockTwoCards({ CardData }) {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [MyWidth, setMyWidth] = useState(window.innerWidth);
  const [countdowns, setCountdowns] = useState(
    CardData.map(() => "0 Days, 0 Hours, 0 Minutes, 0 Seconds")
  );

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scrollToTop2 = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Function to format the time remaining
  const formatTime = (time) => {
    if (time <= 0) return "0 Days, 0 Hours, 0 Minutes, 0 Seconds";

    const days = Math.floor(time / (1000 * 60 * 60 * 24));
    const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((time / (1000 * 60)) % 60);
    const seconds = Math.floor((time / 1000) % 60);

    return `${days} ${t("profile.days")} ${t(
      "profile.and"
    )} ${hours}:${minutes}:${seconds}`;
  };

  const history = useHistory();

  // Function to handle image click and navigation

  const handleDivClick = (TheObject, NameOfCategory) => {
    console.log(TheObject);
    history.push({
      pathname: `/news/${NameOfCategory}`,
      state: TheObject, // Pass CategoryName here
    });
    scrollToTop2();
  };
  // Refs for timers
  const timerRefs = useRef([]);

  useEffect(() => {
    const timers = CardData.map((cardData, index) => {
      const startDate = new Date();
      const endDate = new Date(cardData.dateEnd.split("-").reverse().join("-"));
      let remainingTime = endDate - startDate;

      const updateCountdown = () => {
        remainingTime -= 1000;
        if (remainingTime <= 0) {
          clearInterval(timerRefs.current[index]);
          remainingTime = 0;
        }
        setCountdowns((prev) => {
          const newCountdowns = [...prev];
          newCountdowns[index] = formatTime(remainingTime);
          return newCountdowns;
        });
      };

      timerRefs.current[index] = setInterval(updateCountdown, 1000);
      updateCountdown(); // Initial call to set the countdown immediately

      return timerRefs.current[index];
    });

    return () => {
      timers.forEach((timer) => clearInterval(timer));
    };
  }, [CardData]);

  const carouselRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [showArrows, setShowArrows] = useState(true); //in last of work set it false
  const GoTo = async (TheId, TheLink) => {
    if (TheLink.includes("allcategories")) {
      handleDivClick5(TheId, TheLink);
      return;
    } else {
      try {
        setLoading(false);
        axios
          .post(`${MyDomain}News/GetOneNews`, TheId, {
            headers: {
              "Content-Type": "application/json", // Ensure the server knows the payload type
            },
          })
          .then((response) => {
            setData(response.data);
            handleDivClick(response.data, TheId);
            console.log(response.data);
          })
          .catch((err) => {
            console.log(err.response.data);
          });
      } catch (err) {
        //setError("Failed to fetch product data");
      } finally {
        setLoading(true);
      }
    }
  };
  const handleDivClick5 = (NameOfCategory, TheLink) => {
    history.push({
      pathname: `${TheLink}`,
    });
    scrollToTop2();
  };
  return (
    <div>
      {MyWidth <= 1024 ? (
        <>
          <Carousel
            autoplay
            autoplaySpeed={5000} // every seconds!
            ref={carouselRef}
            arrows={false}
            infinite={true}
            effect={MyWidth <= 1024 ? "none" : "fade"}
            //dots={false}
          >
            {CardData.map((item, index) => (
              <div>
                <div
                  key={index}
                  style={{
                    width: "100%",
                    height: "100%",
                    cursor: "pointer",
                    marginBottom: 25,
                  }}
                >
                  <img
                    src={item?.image}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    onClick={() => {
                      const number = item?.linkToTake.split("/").pop();
                      GoTo(number, item?.linkToTake);
                      //handleDivClick(item?.linkToTake);
                    }}
                  />
                  {/* Display countdown for each card */}
                  <div style={{ marginTop: 10 }}>
                    <a style={{ fontSize: 14, color: "#6b21a8" }}>
                      <a>{t("profile.Specialofferwillendin")} </a>
                      <a>{countdowns[index]}</a>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {CardData.map((item, index) => (
              <div
                key={index}
                style={{ width: "48%", height: "100%", cursor: "pointer" }}
              >
                <img
                  src={
                    i18n.resolvedLanguage === "en"
                      ? item?.image
                      : i18n.resolvedLanguage === "ar"
                      ? item?.imageAr
                      : i18n.resolvedLanguage === "he"
                      ? item?.imageHe
                      : item?.image
                  }
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  onClick={() => {
                    const number = item?.linkToTake.split("/").pop();
                    console.log(number);
                    GoTo(number, item?.linkToTake);
                    //handleDivClick(item, item?.id);

                    //handleDivClick(item?.linkToTake);
                  }}
                />
                {/* Display countdown for each card */}
                <div
                  style={{
                    direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                    paddingTop: 15,
                  }}
                >
                  <a style={{ fontSize: 14, color: "#6b21a8" }}>
                    <a>{t("profile.Specialofferwillendin")} </a>
                    <a>{countdowns[index]}</a>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
